export default __webpack_public_path__ + "static/media/sandwiches.b6ba7185.jpg";